import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
`;

export const Col = styled.div``;

export const DateView = styled.div`
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 1.375em;
  line-height: 1.375em;

  color: #17181a;
`;

export const DayOfTheWeek = styled.div`
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;

  color: #919499;
  &::first-letter {
    text-transform: uppercase;
  }
`;
